import { Outlet } from 'react-router-dom';
import { View, Flex } from '@smarterservices/smarter-ui';

import Sidebar from './Sidebar';
import Header from './Header';
import useUIStore from '../../core/stores/useUIStore';

const AppLayout = () => {
  const uiStore = useUIStore();

  return (
    <Flex height="100vh" as="div">
      <Flex.Item>
        <Sidebar collapsed={uiStore.sidebarCollapsed} />
      </Flex.Item>

      <Flex.Item shouldGrow shouldShrink>
        <Flex direction="column" height="100%">
          <Flex.Item>
            <Header />
          </Flex.Item>

          <Flex.Item shouldGrow shouldShrink>
            <View as="main">
              <Outlet />
            </View>
          </Flex.Item>
        </Flex>
      </Flex.Item>
    </Flex>
  );
};

export default AppLayout;
